const NON_PROD_ENVS = [
  "http://localhost",
  "https://gcp-wow-food-hlt-dial-dev",
  "https://gcp-wow-food-hlt-dial-uat",
];

export const isNonProdEnv = () =>
  NON_PROD_ENVS.some((e) => window.location.href.startsWith(e));
